import { z } from 'zod';
import { maxCodePoints } from '@/lib/forms/primitives';

// Caps mirror 017_drbfm_tables.sql:16 item_name VARCHAR(500) (+ :31 CHECK) and :17 title
// VARCHAR(500). Both ride the same submit (useDRBFM.ts:93-98) and neither input has a maxLength.
// Postgres LENGTH() counts code points, hence maxCodePoints rather than .length.
// Deliberately absent: spec-text cap (TEXT, no CHECK to mirror), predefinedPartLabels rule (component computes partLabelsError), a UUID rule on document ids (they come from a picker).
// No required/cross-field rules: selectCanStartAnalysis (drbfmSlice.selectors.ts:50-53)
// already gates the Start button on the same non-empty predicate, over the same Redux inputData.
export const inputStepSchema = z.object({
  // Cap checks the RAW value — useDRBFM.ts:94 submits itemName untrimmed.
  itemName: z.string().check(maxCodePoints(500, 'validation.maxLength')),
  // Optional in the store; '' when untouched.
  title: z.string().check(maxCodePoints(500, 'validation.maxLength')),
  // Not trimmed: the component submits spec text exactly as typed.
  oldSpecification: z.string(),
  newSpecification: z.string(),
  specOldDocumentId: z.string(),
  specNewDocumentId: z.string(),
});
